import React from "react";
import ReportForm from "../../components/Report/ReportForm";
import { useTranslation } from "react-i18next";

const reports = () => {
  const { t } = useTranslation("report");
  return (
    <>
      <div className="w-full">
        {/* <p style={{ fontWeight: 700 }} className="360:pl-[50px] lg:pl-[0px]">
          Reports
        </p> */}
      </div>

    <div className="md:bg-[#fff] min-h-screen flex flex-col items-center px-2 md:px-0 w-full">
  <div className="flex flex-col justify-start items-start md:max-w-[500px] w-full">
    <div className="pt-[20px] lg:pt-[25px] w-full  md:pr-[3em]">
      <h1
        style={{ fontWeight: 600 }}
        className="text-[20px] text-[#000] whitespace-nowrap w-full "
      >
        {t("report.generateTitle")}
      </h1>
      <p className="whitespace-wrap 360:whitespace-nowrap">
        {t("report.selectionPrompt")}
      </p>
    </div>
  </div>
  <ReportForm />
</div>
    </>
  );
};

export default reports;
